import { fromEvent, merge, Observable } from 'rxjs';
import { Component, Input, Output, EventEmitter, ViewChildren, ElementRef } from '@angular/core';
import { FormGroup, FormControlName } from '@angular/forms';
import { ILookup } from '../shared/lookup';
import { GenericValidator } from '../shared/generic-validator';
import { AuthService } from '../shared/core/index';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';

@Component({
    selector: 'company-contact',
    standalone: false,
    templateUrl: 'company-contact.component.html',
    styleUrls: ['./company-contact.component.css']
})
export class CompanyContactComponent {

    @Input() currentItem: string;
    @Output() selectedItem = new EventEmitter<FormGroup>();
    @Input('group')
    public contactItemForm: FormGroup;
    @Input('count')
    public count: number;
    @Input('current')
    public current: number;
    @Input('lookup')
    public lookup: ILookup[];
    @Output() addItem = new EventEmitter();
    @Output() removeItem = new EventEmitter();

    displayMessage: { [key: string]: string } = {};
    private validationMessages: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

    constructor(public _authService: AuthService) {
        this.validationMessages = {
            email: {
                pattern: 'Please Enter a valid Email.',
                maxlength: 'Contact Title Cannot be Longer than 255 Characters'
            },
            name: {
                maxlength: 'Contact Name Cannot be Longer than 80 Characters'
            },
            contactTitle: {
                maxlength: 'Contact Title Cannot be Longer than 255 Characters'
            },
            address: {
                maxlength: 'Address Cannot be Longer than 255 Characters'
            },
            address2: {
                maxlength: 'Address 2 Cannot be Longer than 255 Characters'
            },
            city: {
                maxlength: 'City Cannot be Longer than 255 Characters'
            },
            state: {
                maxlength: 'State Cannot be Longer than 255 Characters'
            },
            zipCode: {
                maxlength: 'Zip Code Cannot be Longer than 100 Characters'
            },
            country: {
                maxlength: 'Country Cannot be Longer than 255 Characters'
            },
            phoneNumber: {
                maxlength: 'Phone Number Cannot be Longer than 40 Characters'
            },
            cellNumber: {
                maxlength: 'Cell Number Cannot be Longer than 40 Characters'
            },
            faxNumber: {
                maxlength: 'Fax Number Cannot be Longer than 40 Characters'
            },
            phoneNumber2: {
                maxlength: 'Office Phone Number Cannot be Longer than 40 Characters'
            },
            phoneNumber3: {
                maxlength: 'Other Phone Number Cannot be Longer than 40 Characters'
            },
            notes: {
                maxlength: 'Notes Cannot be Longer than 255 Characters'
            }
        };

        this.genericValidator = new GenericValidator(this.validationMessages);
    }

    ngAfterViewInit() {
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));

        merge(this.contactItemForm.valueChanges, ...controlBlurs).pipe(
            debounceTime(500)
        ).subscribe(value => {
            this.displayMessage = this.genericValidator.processMessages(this.contactItemForm);
        });
    }

    isDefaultContact() {
        var retValue = this.currentItem == this.contactItemForm.controls.id.value;
        return retValue;
    }

    addContactItem() {
        this.addItem.emit();
        return false;
    }

    removeContactItem() {
        this.removeItem.emit();
        return false;
    }

    onItemSelectionChange(event) {
        this.selectedItem.next(event);
        return false;
    }
}
